import {
  OTHER_MACHINE_TYPE_ID,
  OTHER_MANUFACTURER_ID,
} from "@app/constants";

export type MachineDetailForUpdate = {
  machineName?: string;
  machineManufacturerId?: string;
  machineTypeId?: string;
  modelAndType?: string;
  serialNumber?: string;
  pictureUrl?: string | null;
  filePath?: string | null;
  pictureUrlDB?: string | null;
  serialNumberPlatePictureUrl?: string | null;
  serialNumberFilePath?: string | null;
  serialNumberPlatePictureUrlDB?: string | null;
  customMachineManufacturerName?: string | null;
  customTypeName?: string | null;
  memo?: string | null;
};

type BuildMachineUpdatePayloadOptions = {
  omitPictureUrls?: boolean;
};

const isFullUrl = (value?: string | null) =>
  !!value && /^https?:\/\//i.test(value);

export function resolveMachinePicturePathForUpdate(
  detail: MachineDetailForUpdate,
): string | null {
  if (detail.filePath) {
    return detail.filePath;
  }

  if (detail.pictureUrlDB) {
    return detail.pictureUrlDB;
  }

  if (detail.pictureUrl && !isFullUrl(detail.pictureUrl)) {
    return detail.pictureUrl;
  }

  return null;
}

export function resolveSerialPlatePicturePathForUpdate(
  detail: MachineDetailForUpdate,
): string | null {
  if (detail.serialNumberFilePath) {
    return detail.serialNumberFilePath;
  }

  if (detail.serialNumberPlatePictureUrlDB) {
    return detail.serialNumberPlatePictureUrlDB;
  }

  if (
    detail.serialNumberPlatePictureUrl &&
    !isFullUrl(detail.serialNumberPlatePictureUrl)
  ) {
    return detail.serialNumberPlatePictureUrl;
  }

  return null;
}

export function buildMachineUpdatePayloadFromDetail(
  detail: MachineDetailForUpdate,
  memo: string | null,
  options?: BuildMachineUpdatePayloadOptions,
) {
  const payload: Record<string, string | null> = {
    machineName: detail.machineName ?? "",
    machineManufacturerId: detail.machineManufacturerId ?? "",
    machineTypeId: detail.machineTypeId ?? "",
    modelAndType: detail.modelAndType ?? "",
    serialNumber: detail.serialNumber ?? "",
    customMachineManufacturerName:
      detail.machineManufacturerId !== OTHER_MANUFACTURER_ID
        ? null
        : detail.customMachineManufacturerName ?? null,
    customTypeName:
      detail.machineTypeId !== OTHER_MACHINE_TYPE_ID
        ? null
        : detail.customTypeName ?? null,
    memo,
  };

  if (!options?.omitPictureUrls) {
    payload.pictureUrl = resolveMachinePicturePathForUpdate(detail);
    payload.serialNumberPlatePictureUrl =
      resolveSerialPlatePicturePathForUpdate(detail);
  }

  return payload;
}
